import React from 'react';
import { HStack, Icon, Text, VStack } from '@chakra-ui/react';

import { TbUserCircle } from 'react-icons/tb';

type Props = {
  onPress: () => void;
};

export default function SideNavLogin(props: Props) {
  const { onPress } = props;
  return (
    <VStack align="stretch">
      <HStack as="button" textAlign="left" onClick={onPress}>
        <Icon as={TbUserCircle} color="blue.500" fontSize={60} />
        <Text flex={1} fontSize={18} fontWeight="bold" color="blue.500">
          {t('Click here to Log In')}
        </Text>
      </HStack>
    </VStack>
  );
}
